export default __webpack_public_path__ + "locales/ko-KR/DeleteDialog.json?hash=8e4ffcb1475479ea9f3911d7524976c0";